
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/space",
      function () {
        return require("private-next-pages/projects/space/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/space"])
      });
    }
  